import { useLocation } from 'react-router-dom';

const useIsPreview = (): boolean => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const quoteId = queryParams.get('id') || '';
    const isPreview = !!Number(quoteId);

    return isPreview;
};

export default useIsPreview;
